// extracted by mini-css-extract-plugin
export var avatar = "_s7-3";
export var avatarContainer = "_s7-2";
export var avatarSpacer = "_s7-5";
export var avatarSpacerContainer = "_s7-4";
export var avatarStackContainer = "_s7-1";
export var bubble = "_s7-0";
export var remainderBubble = "_s7-6";